module.exports = __webpack_public_path__ + "img/example8-3.30e18de0.png";